// The arrival ritual: once per session, on a first landing at the threshold,
// a single point of light ignites the void before the hero settles in.
const KEY = "pp_arrival_v1";

export const ARRIVAL_MS = 2100; // full length of the ignition
export const ARRIVAL_HOLD = 1.5; // seconds the hero waits before it appears

export function arrivalPending() {
  if (typeof window === "undefined") return false;
  try {
    if (window.location.pathname !== "/") return false;
    if (sessionStorage.getItem(KEY)) return false;
  } catch {
    return false;
  }
  const reduced =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  return !reduced;
}

export function markArrivalSeen() {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    /* private mode — the ritual simply plays again next time */
  }
}
